import { render } from "./App.vue?vue&type=template&id=21562c9c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=21562c9c&lang=scss"

import exportComponent from "/home/alex/IdeaProjects/PokemonSpriteEditor2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__